import CardItem from "../../molecules/CardItem/CardItem"

const LoanList = ({LoanList, isActive, onClick, handleActive, setting = {} }) => {

  // console.log(">>> loan list", LoanList)
  return (

  <div onClick={onClick}>
      <CardItem LoanList={LoanList} isActive={isActive} handleActive={handleActive}/>
  </div>
  )

}

export default LoanList